import * as icon_list from "./icon";
import * as background_list from "./background";


export { icon_list, background_list };
